export const locale = {
    lang: 'sk',
    data: {
        NAV: {
            APPLICATIONS: 'Programlar',
            SAMPLE: {
                TITLE: 'Örnek',
                BADGE: '15'
            }
        }
    }
};
